/*
 * fm-vendor-modal.js
 * Single source of truth for the multi-vendor / multi-shipping-location customer
 * message, plus a reusable Bootstrap modal that displays it (with links to the
 * contact page) at add-to-cart time and checkout time.
 * Loaded early in layout/theme.liquid, BEFORE api.jquery.js and ajaxify-shop.js,
 * and after jQuery core. ES5 only. Degrades to native alert() if the Bootstrap
 * modal plugin is unavailable on a given page.
 */
(function () {
  var CONTACT_URL = 'https://flooringmarket.com/pages/contact-us';

  // Plain-text canonical message. MUST match the string pushed into the checkout
  // validationErrors arrays (Steps 4 & 5) so the linked variant can be substituted.
  var MSG_TEXT = 'Your cart includes items from multiple shipping locations. ' +
    'Please contact us with the information on the products you need, and one of our ' +
    'Flooring Specialists will help you with the order. You can provide that information here.';

  // HTML variant with "contact us" and "here" linked to the contact page.
  var MSG_HTML = 'Your cart includes items from multiple shipping locations. Please ' +
    '<a href="' + CONTACT_URL + '">contact us</a> with the information on the products ' +
    'you need, and one of our Flooring Specialists will help you with the order. ' +
    'You can provide that information <a href="' + CONTACT_URL + '">here</a>.';

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function ensureModal() {
    var $ = window.jQuery;
    if (!$) { return null; }
    var existing = document.getElementById('fmVendorModal');
    if (existing) { return $(existing); }
    var markup =
      '<div class="modal fade" id="fmVendorModal" tabindex="-1" role="dialog" aria-labelledby="fmVendorModalLabel">' +
        '<div class="modal-dialog" role="document">' +
          '<div class="modal-content">' +
            '<div class="modal-header">' +
              '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
              '<h4 class="modal-title" id="fmVendorModalLabel">flooringmarket.com</h4>' +
            '</div>' +
            '<div class="modal-body" id="fmVendorModalBody"></div>' +
            '<div class="modal-footer">' +
              '<button type="button" class="btn btn-default" data-dismiss="modal">OK</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    if (!document.getElementById('fm-vendor-modal-styles')) {
      var fmStyle = document.createElement('style');
      fmStyle.id = 'fm-vendor-modal-styles';
      fmStyle.type = 'text/css';
      fmStyle.appendChild(document.createTextNode(
        '#fmVendorModal .modal-body a{text-decoration:underline;}' +
        '#fmVendorModal .modal-body a:hover,#fmVendorModal .modal-body a:focus{text-decoration:underline;}'
      ));
      document.getElementsByTagName('head')[0].appendChild(fmStyle);
    }
    $('body').append(markup);
    return $(document.getElementById('fmVendorModal'));
  }

  function showHtml(bodyHtml) {
    var $ = window.jQuery;
    // Graceful degradation: if jQuery or the Bootstrap modal plugin is missing,
    // fall back to a native alert of the plain text so the customer is still warned.
    if (!$ || typeof $.fn.modal !== 'function') { window.alert(MSG_TEXT); return; }
    var $modal = ensureModal();
    if (!$modal) { window.alert(MSG_TEXT); return; }
    $('#fmVendorModalBody').html(bodyHtml);
    $modal.modal('show');
  }

  function showVendorMessage() { showHtml('<p>' + MSG_HTML + '</p>'); }

  function showErrorList(introText, errors) {
    var html = '<p>' + escapeHtml(introText) + '</p><ul>';
    var list = errors || [];
    for (var i = 0; i < list.length; i++) {
      // Substitute the linked variant for the canonical vendor message; escape all others.
      if (list[i] === MSG_TEXT) { html += '<li>' + MSG_HTML + '</li>'; }
      else { html += '<li>' + escapeHtml(list[i]) + '</li>'; }
    }
    html += '</ul>';
    showHtml(html);
  }

  window.FM_VENDOR_MSG_TEXT = MSG_TEXT;
  window.FM_VENDOR_MSG_HTML = MSG_HTML;
  window.FMModal = { showVendorMessage: showVendorMessage, showErrorList: showErrorList, showHtml: showHtml };
})();
